import { Grid, Link, Button, Menu, MenuItem } from '@mui/material';
import { useNavigate } from "react-router-dom";
import { HeaderMutualLogo } from './icons/Header';
import { useCustomContext } from './ContextHook';
import React, { useState } from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MutualService from '../service/MutualService';
import Navbar from './Navbar'
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import { PIONEER_RELATIVE_PATH, LOGIN_LINK, ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK } from '../utils/main-links'


const Header = () => {
    const navigate = useNavigate();
    const context = useCustomContext();
    const { configs } = useCustomContext();
    const currentEvent = configs?.currentEvent;
    const [openNavbar, setOpenNavbar] = useState(false)
    const backgroundColorHeader = configs?.currentEvent?.theme?.reStyled.backgroundColor || ''

    const backMain = () => {
        navigate(PIONEER_RELATIVE_PATH)
    }

    const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
    const open = Boolean(anchorEl);
    const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };

    //This function needs to be moved to a different layer
    const handleLogout = async () => {
        const result = await MutualService.userLogout()
        if (result.status) {
            context.setIsLoggedContext(false)
        }
    }

    const NavbarLogged = () => {
        return (
            <li>
                <span>{context.user.firstName} {context.user.lastName}</span>
                <ul className='embedded-links'>
                    <li><a href={ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK}>Manage Profile</a></li>
                    <li onClick={handleLogout}>Logout</li>
                </ul>
            </li>
        )
    }
    const eventClassname = currentEvent?.name !== undefined ? currentEvent.name : ''

    if (context.width < 640) {
        if (openNavbar) {
            return (
                <Grid className='open-mobile-navbar' onClick={() => setOpenNavbar(false)}>
                    <CloseIcon className='close-mobile-navbar' />
                    <ul>
                        {context.isLogged ? <NavbarLogged /> : <Link href={LOGIN_LINK} className='login-mobile-navbar'>Log In</Link>}
                    </ul>
                </Grid>
            )
        }
        else {
            return (
                <Grid
                    container
                    className={`header-wrapper-mobile ${eventClassname}`}
                    style={{ backgroundColor: backgroundColorHeader }}
                >
                    <HeaderMutualLogo onClick={backMain} />
                    {context.isLogged ? (
                        <MenuIcon className='header-mobile-icon' onClick={() => setOpenNavbar(true)} />
                    ) : (
                        <ul>
                            <Link href={LOGIN_LINK} className='login-small-screen'>Log In</Link>
                        </ul>
                    )}
                </Grid>
            )
        }
    }
    else {
        return (
            <Grid container justifyContent="center" style={{ position: 'fixed', zIndex: '1000' }} className='nav-bar'>
                <Grid container className={`header-top ${eventClassname}`} justifyContent="center" flexDirection="column">
                    <Grid container flexDirection="row" alignContent="baseline">
                        <Grid container alignContent="baseline" item className="mutual-logo-image" justifyContent="space-between" flexWrap="nowrap">

                            <Grid style={{ alignSelf: 'center' }} >
                                <HeaderMutualLogo onClick={backMain} />
                            </Grid>

                            <Grid
                                container
                                style={{ width: '80%', zIndex: '100' }}
                                flexDirection="row"
                                alignContent="center"
                                justifyContent="space-between"
                                flexWrap="wrap"
                            >
                                <Navbar />

                                <Grid style={{ alignSelf: "center" }}>
                                    {
                                        !context.isLogged
                                            ?
                                            //This is to send to the /login page (external page) 
                                            <Link href={LOGIN_LINK} className='login-btn'>Log In</Link>
                                            :
                                            //This is a drop-down button to send to the account management or logout the user
                                            <div>
                                                <Button
                                                    aria-expanded={open ? 'true' : undefined}
                                                    onClick={handleClick}
                                                    endIcon={<KeyboardArrowDownIcon />}
                                                    style={{ padding: '0px !important' }}
                                                >
                                                    <span style={{ textTransform: 'none' }}>{context.user.firstName} {context.user.lastName}</span>
                                                </Button>
                                                <Menu
                                                    anchorEl={anchorEl}
                                                    open={open}
                                                    onClose={handleClose}
                                                    style={{ padding: '0px !important' }}
                                                >
                                                    <MenuItem>
                                                        <a style={{ textDecoration: 'none', color: 'inherit' }} href={ACCOUNT_SUBSCRIPTION_MANAGEMENT_LINK}>Manage Profile</a>
                                                    </MenuItem>
                                                    <MenuItem onClick={handleLogout}>Logout</MenuItem>
                                                </Menu>
                                            </div>
                                    }
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        )
    }
}

export default Header;
